export default "__VITE_ASSET__ChCBdFKf__"